import React from 'react';
import PropTypes from "prop-types";
import {Button} from 'reactstrap';
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import Tooltip from "@material-ui/core/Tooltip";
import Types from "../../../constants/Types";
import API from "@beardeddevops/react.api";
import syncBodyScrollLock from "../../../utils/syncBodyScrollLock";

export default class CustomerComponent extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		prefix: PropTypes.string,
		locations: PropTypes.array.isRequired,
		history: PropTypes.object.isRequired,
		afterCustomerSave: PropTypes.func.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		onTextUpdate: PropTypes.func.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
		onPersistCustomer: PropTypes.func,
	};

	constructor(props) {
		super(props);

		this.state = {
			customerAddModalOpen: false,
			customerEditModalOpen: false,
		}
	}

	persistCustomer = async (customerPkey) => {
		if (!this.props.object.pkey) {
			return;
		}
		if (typeof this.props.onPersistCustomer === 'function') {
			await this.props.onPersistCustomer(customerPkey);
			return;
		}
		const checkout = new API.BuildClass(Types.Checkouts._name, API.RequestType.UPDATE);
		checkout.object.pkey = this.props.object.pkey;
		checkout.object.customer = customerPkey || null;
		checkout.object.client = this.props.object.client || '';
		await checkout.submit(null, 'POST_CUSTOMER', true);
	}

	handleAfterSave = (data) => {
		if (typeof this.props.afterCustomerSave === 'function') {
			this.props.afterCustomerSave(data);
		}
		void this.persistCustomer(data?.pkey);
	}

	selectUpdate = (name, pkey, name_plural, data) => {
		if (typeof this.props.onSelectUpdate === 'function') {
			this.props.onSelectUpdate(name, pkey, name_plural, data);
		}
		const currentCustomer = this.props.object?.customer;
		if (pkey != null && String(pkey) === String(currentCustomer ?? '')) {
			return;
		}
		void this.persistCustomer(pkey);
	}

	handleToggleCustomerAddModal = () => {
		const wasOpen = this.state.customerAddModalOpen;
		this.setState(
			{ customerAddModalOpen: !wasOpen },
			wasOpen ? this.syncBodyScrollLock : undefined
		);
	}

	handleToggleCustomerEditModal = () => {
		const wasOpen = this.state.customerEditModalOpen;
		this.setState(
			{ customerEditModalOpen: !wasOpen },
			wasOpen ? this.syncBodyScrollLock : undefined
		);
	}

	syncBodyScrollLock = () => {
		syncBodyScrollLock();
	}

	render() {

		let object = this.props.object;
		let {properties, shouldLoad, onTextUpdate, history} = this.props;
		let {customerAddModalOpen, customerEditModalOpen} = this.state;
		let prefix = typeof this.props.prefix !== 'undefined' ? this.props.prefix : 'customer_';
		return (
			<div>
				<div className={'form-group'}>
					<div className="row">
						<div className="col-3">
							<span className="input-label" style={{paddingLeft: 5}}>Customer</span>
							<Framework.Elements.UniversalModal
								locations={this.props.locations}
								history={history}
								name={"Customer"}
								object={Objects.Customer}
								showModal={customerAddModalOpen}
								objectProps={{
									hideSave: true
								}}
								handleToggle={this.handleToggleCustomerAddModal}
								afterSave={(data) => this.handleAfterSave(data)}
								url={'customers'}
								project={'pos'}
							/>
							<Framework.Elements.UniversalModal
								locations={this.props.locations}
								history={history}
								id={object.customer}
								name={"Customer"}
								object={Objects.Customer}
								objectProps={{
									object: object.customers,
									hideSave: true
								}}
								showModal={customerEditModalOpen}
								handleToggle={this.handleToggleCustomerEditModal}
								afterSave={(data) => this.handleAfterSave(data)}
								size={"xl"}
								url={'customers'}
								hideGoTo={true}
								project={'pos'}
							/>
						</div>
						<div className="col-9 d-flex">
							<Button data-id={'add-customer'} onClick={this.handleToggleCustomerAddModal} className={"select-add outline-button-primary"}
							        size={"sm"} outline>
								<i className={"fa fa-plus"}/>
							</Button>
							{object.customer &&
								<Button data-id={'edit-customer'} onClick={this.handleToggleCustomerEditModal} className={"select-add"}
								        size={"sm"} outline color="green-meadow">
									<i className={"fa fa-pencil"}/>
								</Button>}
							{object.customer &&
								<Tooltip title="To Customer" aria-label="To customer">
									<Button
										className={"select-add outline-secondary-button"}
										size={"sm"} outline
										onClick={() => history.push('/customers/' + object.customer)}>
										<i className={"fa fa-id-card-o"}/>
									</Button>
								</Tooltip>}
							<div className={'flex-grow-1'} data-id={'my-customer'}>
								<Framework.Elements.Select
									shouldLoad={shouldLoad}
									update={(name, pkey, name_plural, data) => this.selectUpdate(name, pkey, name_plural, data)}
									property={properties.customer}
									value={object.customer}
									error={object.customer_error}
									model={Types.Customers._name}
									object={object.customers}
									text={'name'}
									sort={'name'}
									nullable={true}
								/>
							</div>
						</div>
					</div>
				</div>

				<Objects.Customer
					id={object.customer ?? null}
					properties={properties}
					onTextUpdate={onTextUpdate}
					prefix={prefix}
					disableFields={true}
					noDelete={false}
					hideSave={true}
				/>

			</div>
		);
	}
}
